import xugarHero from './modules/xugarHero';
import nightscout from './modules/nightscout';
import game from './modules/game';

export default {
  modules: {
    xugarHero,
    nightscout,
    game
  }
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/store/index.js